import { formatPercentage } from 'components/featured/Deals/components/DealDetailsMain/Details/utils';
import { formatDealAmount } from 'helper/short-currency';
import { PlatformMetrics } from '../types';

export const statsData: { id: keyof PlatformMetrics; label: string; format?: Function }[] = [
  { id: 'activeDealCount', label: 'Active Deals' },
  { id: 'totalDealCount', label: 'Total Deals' },
  { id: 'wonValue', label: 'Won Value', format: formatDealAmount },
  { id: 'successRate', label: 'Success Rate', format: formatPercentage },
  { id: 'ourContacts', label: 'Our Contacts' },
];
